import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const InverterDatepicker = ({ startDate, endDate, setStartDate, setEndDate }) => {
  console.log("startDate", startDate);

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);

      console.log("From: ", dates[0], ", to: ", dates[1]);
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
      console.log("Clear");
    }
  };

  const rangePresets = [
    { label: "Today", value: [dayjs(), dayjs()] },
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs()] },
    { label: "Last Week", value: [dayjs().subtract(1, "week"), dayjs()] },
    { label: "Last Month", value: [dayjs().subtract(1, "month"), dayjs()] },
    { label: "Last Quarter", value: [dayjs().subtract(3, "months"), dayjs()] },
  ];

  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <div className="range-picker-container">
      <RangePicker
        presets={rangePresets}
        onChange={onRangeChange}
        disabledDate={disableFutureDates}
        // Set the default value using the startDate and endDate props
        // Ensure they are dayjs objects for the RangePicker
        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
      />
      {/* Display selected dates */}
    </div>
  );
};

export default InverterDatepicker;
